/** @jsx h */
import { FunctionalComponent, h } from 'preact';
import { Container, FlexContainer, LeftContainer, RightContainer } from './footerStyled';
import { IMenuLocationModel } from '../../models/MenuLocation';

import FooterAppLinks from '../desktopNav/menuLocations/footerAppLinks';
import FooterTopLinks from '../desktopNav/menuLocations/footerTopLinks';
import FooterSocialLinks from '../desktopNav/menuLocations/footerSocialLinks';
import FooterBottomLinks from '../desktopNav/menuLocations/footerBottomLinks';
import FooterContentBlock from '../desktopNav/menuLocations/footerContentBlock';
import { IMainModel } from '../../models/Main';
import { DeviceTypes } from '../../utils/device';
import FooterFaq from '../desktopNav/menuLocations/footerFaq';

export interface IFooter {
  faqLocation?: IMenuLocationModel;
  topLinksLocation?: IMenuLocationModel;
  bottomLinksLocation?: IMenuLocationModel;
  appLinksLocation?: IMenuLocationModel;
  socialLinksLocation?: IMenuLocationModel;
  contentBlockLocation?: IMenuLocationModel;
  main: IMainModel;
}

const Footer: FunctionalComponent<IFooter> = ({
  faqLocation,
  topLinksLocation,
  socialLinksLocation,
  bottomLinksLocation,
  appLinksLocation,
  contentBlockLocation,
  main: { device },
}) => (
  <Container>
    <FlexContainer>
      <LeftContainer>
        {faqLocation && <FooterFaq menuLocation={faqLocation} />}
        {topLinksLocation && <FooterTopLinks menuLocation={topLinksLocation} />}
        {socialLinksLocation && device === DeviceTypes.mobile && (
          <FooterSocialLinks menuLocation={socialLinksLocation} />
        )}
        {appLinksLocation && <FooterAppLinks menuLocation={appLinksLocation} />}
      </LeftContainer>
      <RightContainer>
        {contentBlockLocation && (
          <FooterContentBlock menuLocation={contentBlockLocation}>
            {socialLinksLocation && device !== DeviceTypes.mobile ? (
              <FooterSocialLinks menuLocation={socialLinksLocation} />
            ) : undefined}
          </FooterContentBlock>
        )}
      </RightContainer>
    </FlexContainer>
    {bottomLinksLocation && <FooterBottomLinks menuLocation={bottomLinksLocation} />}
  </Container>
);

export default Footer;
